<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="dedicationPage_01"><p class="dedicationHead"><span><em class="italic"><span>For</span></em></span></p><p class="dedicationHead"><span>S<span class="small">USANNE</span> K<span class="small">IRK</span></span></p><p class="dedicationText"><span><em class="italic"><span>Brilliant editor, devoted friend,<br/>
crime fiction scholar</span></em></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743250702_dedicationPage_01.vue?0d5d7780